import AllIcons from 'constant/AllIcons'
import { logout_tradly } from '../Auth/Logout'

export var menus = [
  {
    title: '',
    child: [
      {
        name: 'Workspace',
        endpoint: '/workspace',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 h-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
            />
          </svg>
        ),
      },

      {
        name: 'SuperAdmin',
        endpoint: 'https://superadmin.tradly.app',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className={`w-5 h-5 flex-shrink-0    `}
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
            />
          </svg>
        ),
        blank_target: true,
      },
      {
        name: 'Web Editor',
        endpoint: '/editor',
        icon: (
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.2196 13.9555C17.2636 10.0595 14.7915 6.03562 10.731 4.94761C6.14492 3.71877 -0.364424 6.91181 1.08416 11.0092C1.56325 12.3643 2.48817 12.6814 4.23088 12.7061L4.33978 12.7075C5.26123 12.7191 5.52041 12.7792 5.59794 12.9054C5.72536 13.1128 5.72679 13.4439 5.58387 14.3543C5.51634 14.7845 5.49418 14.9355 5.46808 15.1703C5.30897 16.6011 5.55075 17.7169 6.48838 18.7268C9.41611 21.8802 15.0412 18.3535 16.2196 13.9555ZM2.96979 10.3425C2.24104 8.28126 6.9056 5.99314 10.2134 6.87946C13.2298 7.68772 15.0393 10.6331 14.2878 13.4379C13.4497 16.5656 9.50636 19.0379 7.95406 17.366C7.47464 16.8496 7.35504 16.2977 7.45583 15.3913C7.47737 15.1975 7.49709 15.0631 7.55967 14.6645C7.77887 13.2683 7.77611 12.6302 7.30206 11.8585C6.70834 10.8921 6.00236 10.7282 4.36491 10.7076L4.25922 10.7063C3.29465 10.6926 3.06582 10.6141 2.96979 10.3425Z"
              fill="currentColor"
            />
            <path
              d="M6 10C5.30964 10 4.75 9.44036 4.75 8.75C4.75 8.05964 5.30964 7.5 6 7.5C6.69036 7.5 7.25 8.05964 7.25 8.75C7.25 9.44036 6.69036 10 6 10Z"
              fill="currentColor"
            />
            <path
              d="M9.75 10C9.05964 10 8.5 9.44036 8.5 8.75C8.5 8.05964 9.05964 7.5 9.75 7.5C10.4404 7.5 11 8.05964 11 8.75C11 9.44036 10.4404 10 9.75 10Z"
              fill="currentColor"
            />
            <path
              d="M12.25 13C11.5596 13 11 12.4404 11 11.75C11 11.0596 11.5596 10.5 12.25 10.5C12.9404 10.5 13.5 11.0596 13.5 11.75C13.5 12.4404 12.9404 13 12.25 13Z"
              fill="currentColor"
            />
            <path
              d="M10.75 16.5C10.0596 16.5 9.5 15.9404 9.5 15.25C9.5 14.5596 10.0596 14 10.75 14C11.4404 14 12 14.5596 12 15.25C12 15.9404 11.4404 16.5 10.75 16.5Z"
              fill="currentColor"
            />
            <path
              d="M14.3707 3.60451C14.8605 3.34411 15.466 3.52923 15.7253 4.01686C15.7308 4.02727 15.7362 4.03777 15.7413 4.04836L19.8336 12.4482C19.9869 12.7628 19.8635 13.1422 19.5545 13.3065C19.2452 13.471 18.8612 13.3618 18.6847 13.0592L13.9771 4.98893C13.6993 4.5127 13.8602 3.90144 14.3364 3.62364C14.3477 3.61704 14.3592 3.61066 14.3707 3.60451Z"
              fill="currentColor"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.5375 3.48434C13.0238 4.39897 13.8434 4.65522 14.6347 4.23444C15.4262 3.81362 15.6726 2.99053 15.1863 2.07592C14.6289 1.0276 13.438 0.0775719 12.6482 0.497483C11.8585 0.917395 11.9801 2.43602 12.5375 3.48434ZM13.4204 3.01486C13.2581 2.70947 13.1315 2.26269 13.1007 1.8773C13.0806 1.62643 13.1063 1.45889 13.1151 1.40204C13.1171 1.38903 13.1182 1.38181 13.1176 1.38073C13.1183 1.38172 13.1245 1.38462 13.1356 1.38985C13.1866 1.41372 13.3408 1.48594 13.5391 1.64416C13.8414 1.88525 14.141 2.24 14.3034 2.54539C14.5316 2.97464 14.4668 3.19118 14.1653 3.3515C13.8641 3.51165 13.6488 3.44435 13.4204 3.01486Z"
              fill="currentColor"
            />
          </svg>
        ),
      },
    ],
  },
  {
    title: 'Manage',
    child: [
      {
        name: 'Templates',
        endpoint: '/workspace/templates',
        sub_endpoints: ['/workspace/templates/[template_slug]'],

        icon: (
          <svg
            className={`w-5 h-4 flex-shrink-0  fill-current  `}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M19 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V19C0 19.2652 0.105357 19.5196 0.292893 19.7071C0.48043 19.8946 0.734784 20 1 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0ZM9 18H2V8H9V18ZM18 18H11V8H18V18ZM18 6H2V2H18V6Z" />
          </svg>
        ),
      },
      {
        name: 'Integrations',
        endpoint: '/workspace/integrations',
        sub_endpoints: ['/workspace/integrations/[integrations_slug]'],
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z"
            />
          </svg>
        ),
      },
      {
        name: 'Pages',
        endpoint: '/workspace/p',
        sub_endpoints: ['/workspace/p/add_page', '/workspace/p/edit_page'],
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
            />
          </svg>
        ),
      },

      {
        name: 'Blogs',
        endpoint: '/workspace/blog',
        sub_endpoints: ['/workspace/blog/edit_blogpost', '/workspace/blog/add_blogpost'],
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-5V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z"
            />
          </svg>
        ),
      },
    ],
  },
  {
    title: 'BUSINESS SETTINGS',
    child: [
      {
        name: 'My Account',
        endpoint: '/workspace/account',
        icon: (
          <svg className={`w-4 h-4 flex-shrink-0 fill-current  `} viewBox="0 0 16 16">
            <path d="M12.311 9.527c-1.161-.393-1.85-.825-2.143-1.175A3.991 3.991 0 0012 5V4c0-2.206-1.794-4-4-4S4 1.794 4 4v1c0 1.406.732 2.639 1.832 3.352-.292.35-.981.782-2.142 1.175A3.942 3.942 0 001 13.26V16h14v-2.74c0-1.69-1.081-3.19-2.689-3.733zM6 4c0-1.103.897-2 2-2s2 .897 2 2v1c0 1.103-.897 2-2 2s-2-.897-2-2V4zm7 10H3v-.74c0-.831.534-1.569 1.33-1.838 1.845-.624 3-1.436 3.452-2.422h.436c.452.986 1.607 1.798 3.453 2.422A1.943 1.943 0 0113 13.26V14z" />
          </svg>
        ),
      },
      {
        name: 'Custom Domain',
        endpoint: '/workspace/domain',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`w-4 h-4 flex-shrink-0 fill-current  `}
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z"
              clip-rule="evenodd"
            />
          </svg>
        ),
      },
      {
        name: '  User Management',
        endpoint: '/workspace/user-management',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`w-4 h-4 flex-shrink-0 fill-current  `}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        ),
      },
      {
        name: 'Plans',
        endpoint: '/workspace/plans',
        icon: (
          <svg
            width="20"
            height="20"
            className={`w-4 h-4 flex-shrink-0 fill-current`}
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.71 19.29L18 17.56C18 17.45 18 17.35 18 17.25C18 16.8889 17.9289 16.5313 17.7907 16.1976C17.6525 15.864 17.4499 15.5608 17.1945 15.3055C16.9392 15.0501 16.636 14.8475 16.3024 14.7093C15.9687 14.5711 15.6111 14.5 15.25 14.5H14.91L13.47 13.06C13.5579 13.0201 13.6534 12.9996 13.75 13H17C17.2652 13 17.5196 12.8946 17.7071 12.7071C17.8946 12.5196 18 12.2652 18 12C18 11.7348 17.8946 11.4804 17.7071 11.2929C17.5196 11.1054 17.2652 11 17 11H15.5V10C15.5 9.73478 15.3946 9.48043 15.2071 9.29289C15.0196 9.10536 14.7652 9 14.5 9C14.2348 9 13.9804 9.10536 13.7929 9.29289C13.6054 9.48043 13.5 9.73478 13.5 10V11C12.9626 11.0477 12.4512 11.2529 12.03 11.59L10.71 10.26C10.5217 10.0717 10.2663 9.96591 10 9.96591C9.7337 9.96591 9.4783 10.0717 9.29 10.26C9.1017 10.4483 8.99591 10.7037 8.99591 10.97C8.99591 11.2363 9.1017 11.4917 9.29 11.68L11 13.44C11 13.55 11 13.65 11 13.75C11 14.4793 11.2897 15.1788 11.8055 15.6945C12.3212 16.2103 13.0207 16.5 13.75 16.5H14.09L15.53 17.94C15.4421 17.9799 15.3466 18.0004 15.25 18H12C11.7348 18 11.4804 18.1054 11.2929 18.2929C11.1054 18.4804 11 18.7348 11 19C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20H13.5V21C13.5 21.2652 13.6054 21.5196 13.7929 21.7071C13.9804 21.8946 14.2348 22 14.5 22C14.7652 22 15.0196 21.8946 15.2071 21.7071C15.3946 21.5196 15.5 21.2652 15.5 21V20C16.0511 19.9496 16.5741 19.7334 17 19.38L18.32 20.71C18.413 20.8037 18.5236 20.8781 18.6454 20.9289C18.7673 20.9797 18.898 21.0058 19.03 21.0058C19.162 21.0058 19.2927 20.9797 19.4146 20.9289C19.5364 20.8781 19.647 20.8037 19.74 20.71C19.8318 20.6151 19.9039 20.5029 19.9521 20.38C20.0003 20.257 20.0237 20.1258 20.0209 19.9937C20.0181 19.8617 19.9892 19.7316 19.9358 19.6108C19.8825 19.49 19.8057 19.381 19.71 19.29ZM8 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H9V6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7H15C15.1974 6.99901 15.3901 6.93961 15.5539 6.82928C15.7176 6.71895 15.845 6.56262 15.92 6.38C15.9966 6.19789 16.0175 5.99718 15.9801 5.80319C15.9428 5.6092 15.8488 5.43062 15.71 5.29L10.71 0.29C10.6273 0.212216 10.5328 0.148081 10.43 0.1H10.34C10.2508 0.0561488 10.1568 0.0225994 10.06 0H3C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H8C8.26522 20 8.51957 19.8946 8.70711 19.7071C8.89464 19.5196 9 19.2652 9 19C9 18.7348 8.89464 18.4804 8.70711 18.2929C8.51957 18.1054 8.26522 18 8 18ZM11 3.41L12.59 5H11V3.41Z"
              fill="currentColor"
            />
          </svg>
        ),
      },
      {
        name: 'Invoices',
        endpoint: '/workspace/invoices',
        icon: (
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.55281 1.60553C7.10941 1.32725 7.77344 1 9 1C10.2265 1 10.8906 1.32722 11.4472 1.6055L11.4631 1.61347C11.8987 1.83131 12.2359 1.99991 13 1.99993C14.2371 1.99998 14.9698 1.53871 15.2141 1.35512C15.5944 1.06932 16.0437 1.09342 16.3539 1.2369C16.6681 1.38223 17 1.72899 17 2.24148L17 13H20C21.6562 13 23 14.3415 23 15.999V19C23 19.925 22.7659 20.6852 22.3633 21.2891C21.9649 21.8867 21.4408 22.2726 20.9472 22.5194C20.4575 22.7643 19.9799 22.8817 19.6331 22.9395C19.4249 22.9742 19.2116 23.0004 19 23H5C4.07502 23 3.3148 22.7659 2.71092 22.3633C2.11331 21.9649 1.72739 21.4408 1.48057 20.9472C1.23572 20.4575 1.11827 19.9799 1.06048 19.6332C1.03119 19.4574 1.01616 19.3088 1.0084 19.2002C1.00194 19.1097 1.00003 19.0561 1 19V2.24146C1 1.72899 1.33184 1.38223 1.64606 1.2369C1.95628 1.09341 2.40561 1.06931 2.78589 1.35509C3.03019 1.53868 3.76289 1.99993 5 1.99993C5.76415 1.99993 6.10128 1.83134 6.53688 1.6135L6.55281 1.60553ZM3.00332 19L3 3.68371C3.54018 3.86577 4.20732 3.99993 5 3.99993C6.22656 3.99993 6.89059 3.67269 7.44719 3.39441L7.46312 3.38644C7.89872 3.1686 8.23585 3 9 3C9.76417 3 10.1013 3.16859 10.5369 3.38643L10.5528 3.39439C11.1094 3.67266 11.7734 3.9999 13 3.99993C13.7927 3.99996 14.4598 3.86581 15 3.68373V19C15 19.783 15.1678 20.448 15.4635 21H5C4.42498 21 4.0602 20.8591 3.82033 20.6992C3.57419 20.5351 3.39761 20.3092 3.26943 20.0528C3.13928 19.7925 3.06923 19.5201 3.03327 19.3044C3.01637 19.2029 3.00612 19.1024 3.00332 19ZM19.3044 20.9667C19.5201 20.9308 19.7925 20.8607 20.0528 20.7306C20.3092 20.6024 20.5351 20.4258 20.6992 20.1797C20.8591 19.9398 21 19.575 21 19V15.999C21 15.4474 20.5529 15 20 15H17L17 19C17 19.575 17.1409 19.9398 17.3008 20.1797C17.4649 20.4258 17.6908 20.6024 17.9472 20.7306C18.2075 20.8607 18.4799 20.9308 18.6957 20.9667C18.8012 20.9843 18.8869 20.9927 18.9423 20.9967C19.0629 21.0053 19.1857 20.9865 19.3044 20.9667Z"
              fill="currentColor"
            />
            <path
              d="M5 8C5 7.44772 5.44772 7 6 7H12C12.5523 7 13 7.44772 13 8C13 8.55229 12.5523 9 12 9H6C5.44772 9 5 8.55229 5 8Z"
              fill="currentColor"
            />
            <path
              d="M5 12C5 11.4477 5.44772 11 6 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H6C5.44772 13 5 12.5523 5 12Z"
              fill="currentColor"
            />
            <path
              d="M5 16C5 15.4477 5.44772 15 6 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H6C5.44772 17 5 16.5523 5 16Z"
              fill="currentColor"
            />
          </svg>
        ),
      },
    ],
  },

  {
    title: 'Developer',
    child: [
      {
        name: 'Webhooks',
        endpoint: '/workspace/webhooks?page=1',
        icon: (
          <svg
            width="23"
            height="21"
            className={`w-4 h-4 flex-shrink-0 fill-current  `}
            viewBox="0 0 23 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17 6H18V7C18 7.26521 18.1054 7.51957 18.2929 7.7071C18.4804 7.89464 18.7348 8 19 8C19.2652 8 19.5196 7.89464 19.7071 7.7071C19.8946 7.51957 20 7.26521 20 7V6H21C21.2652 6 21.5196 5.89464 21.7071 5.7071C21.8946 5.51957 22 5.26521 22 5C22 4.73478 21.8946 4.48043 21.7071 4.29289C21.5196 4.10535 21.2652 4 21 4H20V3C20 2.73478 19.8946 2.48043 19.7071 2.29289C19.5196 2.10535 19.2652 2 19 2C18.7348 2 18.4804 2.10535 18.2929 2.29289C18.1054 2.48043 18 2.73478 18 3V4H17C16.7348 4 16.4804 4.10535 16.2929 4.29289C16.1054 4.48043 16 4.73478 16 5C16 5.26521 16.1054 5.51957 16.2929 5.7071C16.4804 5.89464 16.7348 6 17 6ZM19 15C18.3793 15.0032 17.7748 15.1988 17.27 15.56L14.82 14.11C14.9356 13.7512 14.9963 13.377 15 13C14.9971 12.1154 14.7011 11.2568 14.1583 10.5584C13.6155 9.85993 12.8565 9.36113 12 9.14V6.82C12.6672 6.5841 13.2296 6.11993 13.5876 5.50952C13.9457 4.89911 14.0765 4.18176 13.9568 3.48426C13.8371 2.78677 13.4747 2.15403 12.9337 1.69789C12.3926 1.24175 11.7077 0.99157 11 0.99157C10.2923 0.99157 9.60741 1.24175 9.06634 1.69789C8.52527 2.15403 8.16288 2.78677 8.04321 3.48426C7.92353 4.18176 8.05429 4.89911 8.41237 5.50952C8.77045 6.11993 9.33279 6.5841 10 6.82V9.14C9.14353 9.36113 8.38451 9.85993 7.84169 10.5584C7.29887 11.2568 7.00287 12.1154 7 13C7.00372 13.377 7.0644 13.7512 7.18 14.11L4.73 15.56C4.22516 15.1988 3.62072 15.0032 3 15C2.40666 15 1.82664 15.1759 1.33329 15.5056C0.839943 15.8352 0.455426 16.3038 0.228363 16.8519C0.00129986 17.4001 -0.0581102 18.0033 0.0576455 18.5853C0.173401 19.1672 0.459123 19.7018 0.878681 20.1213C1.29824 20.5409 1.83279 20.8266 2.41473 20.9424C2.99667 21.0581 3.59987 20.9987 4.14805 20.7716C4.69623 20.5446 5.16477 20.1601 5.49441 19.6667C5.82405 19.1734 6 18.5933 6 18C5.9963 17.7291 5.95594 17.46 5.88 17.2L8.18 15.83C8.92945 16.575 9.94326 16.9932 11 16.9932C12.0567 16.9932 13.0706 16.575 13.82 15.83L16.12 17.2C15.9524 17.8056 15.9793 18.4485 16.1967 19.0381C16.4141 19.6276 16.8112 20.134 17.3318 20.4858C17.8525 20.8376 18.4705 21.017 19.0986 20.9987C19.7267 20.9804 20.3332 20.7654 20.8325 20.384C21.3318 20.0026 21.6988 19.4739 21.8816 18.8728C22.0644 18.2716 22.0538 17.6282 21.8514 17.0333C21.6489 16.4385 21.2648 15.9222 20.7532 15.5574C20.2416 15.1926 19.6284 14.9976 19 15ZM3 19C2.80222 19 2.60888 18.9413 2.44443 18.8315C2.27998 18.7216 2.15181 18.5654 2.07612 18.3827C2.00043 18.2 1.98063 17.9989 2.01922 17.8049C2.0578 17.6109 2.15304 17.4327 2.29289 17.2929C2.43275 17.153 2.61093 17.0578 2.80491 17.0192C2.99889 16.9806 3.19996 17.0004 3.38268 17.0761C3.56541 17.1518 3.72159 17.28 3.83147 17.4444C3.94135 17.6089 4 17.8022 4 18C4 18.2652 3.89464 18.5196 3.70711 18.7071C3.51957 18.8946 3.26522 19 3 19ZM11 3C11.1978 3 11.3911 3.05865 11.5556 3.16853C11.72 3.27841 11.8482 3.43459 11.9239 3.61731C11.9996 3.80004 12.0194 4.00111 11.9808 4.19509C11.9422 4.38907 11.847 4.56725 11.7071 4.7071C11.5673 4.84696 11.3891 4.9422 11.1951 4.98078C11.0011 5.01937 10.8 4.99956 10.6173 4.92388C10.4346 4.84819 10.2784 4.72002 10.1685 4.55557C10.0587 4.39112 10 4.19778 10 4C10 3.73478 10.1054 3.48043 10.2929 3.29289C10.4804 3.10535 10.7348 3 11 3ZM11 15C10.6044 15 10.2178 14.8827 9.88886 14.6629C9.55996 14.4432 9.30362 14.1308 9.15224 13.7654C9.00087 13.3999 8.96126 12.9978 9.03843 12.6098C9.1156 12.2219 9.30608 11.8655 9.58579 11.5858C9.86549 11.3061 10.2219 11.1156 10.6098 11.0384C10.9978 10.9613 11.3999 11.0009 11.7654 11.1522C12.1308 11.3036 12.4432 11.56 12.6629 11.8889C12.8827 12.2178 13 12.6044 13 13C13 13.5304 12.7893 14.0391 12.4142 14.4142C12.0391 14.7893 11.5304 15 11 15ZM19 19C18.8022 19 18.6089 18.9413 18.4444 18.8315C18.28 18.7216 18.1518 18.5654 18.0761 18.3827C18.0004 18.2 17.9806 17.9989 18.0192 17.8049C18.0578 17.6109 18.153 17.4327 18.2929 17.2929C18.4327 17.153 18.6109 17.0578 18.8049 17.0192C18.9989 16.9806 19.2 17.0004 19.3827 17.0761C19.5654 17.1518 19.7216 17.28 19.8315 17.4444C19.9414 17.6089 20 17.8022 20 18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19Z" />
          </svg>
        ),
      },
      {
        name: 'JS SDK',
        endpoint: '/workspace/js_sdk',
        icon: (
          <svg
            className={`w-4 h-4 flex-shrink-0 fill-current  `}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12.4783 12.8829C11.7264 12.9562 10.9689 12.8183 10.2911 12.4846C10.1375 12.3618 10.0108 12.2088 9.91867 12.035C9.82658 11.8613 9.77107 11.6705 9.75558 11.4745C9.75527 11.4451 9.74914 11.4161 9.73755 11.3892C9.72596 11.3622 9.70914 11.3379 9.68807 11.3175C9.66699 11.297 9.64208 11.281 9.61477 11.2703C9.58745 11.2596 9.55829 11.2544 9.52896 11.255C9.21237 11.2512 8.89584 11.252 8.57931 11.2546C8.52399 11.249 8.46868 11.2654 8.42536 11.3002C8.38205 11.3351 8.35423 11.3856 8.34793 11.4409C8.32988 11.7848 8.38802 12.1285 8.5182 12.4474C8.64838 12.7662 8.84738 13.0524 9.10098 13.2854C9.74118 13.785 10.5185 14.0774 11.3293 14.1236C12.174 14.2216 13.0289 14.1853 13.8623 14.0161C14.5023 13.8967 15.089 13.5805 15.5406 13.1117C15.7902 12.8039 15.9575 12.4377 16.0268 12.0474C16.0961 11.6572 16.065 11.2558 15.9366 10.8809C15.8287 10.6166 15.6617 10.3805 15.4484 10.1908C15.2351 10.0011 14.9812 9.86272 14.7062 9.78635C13.4254 9.33695 12.0419 9.37094 10.7362 9.02945C10.5095 8.9581 10.2325 8.88065 10.1315 8.64066C10.0731 8.47178 10.0691 8.28885 10.1201 8.11758C10.1711 7.94632 10.2744 7.79534 10.4157 7.68588C10.8256 7.45158 11.2925 7.33536 11.7644 7.35007C12.405 7.28977 13.0507 7.38216 13.6486 7.61966C13.8282 7.72529 13.9827 7.86876 14.1013 8.0401C14.2199 8.21143 14.2997 8.40654 14.3354 8.61185C14.3371 8.67244 14.3614 8.7302 14.4035 8.7738C14.4456 8.8174 14.5025 8.84368 14.563 8.8475C14.8773 8.85391 15.1917 8.84921 15.5061 8.84964C15.5606 8.85616 15.6156 8.84278 15.661 8.81197C15.7065 8.78116 15.7393 8.73498 15.7534 8.68192C15.7562 8.25793 15.6482 7.84057 15.44 7.47117C15.2319 7.10178 14.9308 6.79317 14.5667 6.57592C13.5617 6.1121 12.4462 5.94142 11.3485 6.08349V6.08341C10.5443 6.11638 9.77586 6.42513 9.17238 6.95779C8.89533 7.2564 8.70772 7.62682 8.63092 8.02686C8.55412 8.42689 8.59122 8.84045 8.738 9.22043C8.85225 9.47497 9.02034 9.70171 9.23068 9.88501C9.44102 10.0683 9.68861 10.2038 9.95638 10.2822C11.2329 10.7433 12.6319 10.5953 13.9208 11.003C14.172 11.0882 14.4644 11.2185 14.5414 11.4981C14.5827 11.6656 14.5796 11.841 14.5323 12.007C14.485 12.173 14.3952 12.3237 14.2718 12.4442C13.7357 12.7772 13.1075 12.9309 12.4783 12.8829ZM18.2972 4.43753C15.805 3.0282 13.3121 1.62014 10.8188 0.21335C10.5686 0.0734586 10.2867 8.58307e-06 10.0001 8.58307e-06C9.71346 8.58307e-06 9.43161 0.0734586 9.18143 0.21335C6.69775 1.61588 4.21393 3.01835 1.72998 4.42075C1.48834 4.55246 1.28633 4.74643 1.14492 4.98252C1.00351 5.21862 0.927851 5.48826 0.925781 5.76346V14.2377C0.929758 14.5179 1.0095 14.7918 1.15654 15.0304C1.30358 15.2689 1.51245 15.4632 1.76098 15.5927C2.47449 15.9811 3.16772 16.409 3.89416 16.7715C4.31344 16.9957 4.77914 17.1192 5.25439 17.1322C5.72965 17.1453 6.20142 17.0476 6.63238 16.8468C6.95485 16.6448 7.21724 16.36 7.39222 16.0221C7.56719 15.6842 7.64834 15.3056 7.6272 14.9256C7.63275 12.129 7.62805 9.33214 7.62933 6.53539C7.6342 6.50481 7.63255 6.47355 7.6245 6.44366C7.61645 6.41376 7.60217 6.3859 7.5826 6.36191C7.56303 6.33791 7.53861 6.31833 7.51095 6.30442C7.48328 6.29052 7.45299 6.28262 7.42206 6.28124C7.10467 6.27611 6.7868 6.27824 6.46942 6.28039C6.44003 6.27775 6.41042 6.28136 6.38252 6.29097C6.35463 6.30058 6.32908 6.31597 6.30755 6.33615C6.28602 6.35633 6.269 6.38083 6.2576 6.40804C6.24621 6.43526 6.24069 6.46457 6.24142 6.49407C6.23715 9.27282 6.24228 12.0524 6.23886 14.8315C6.23959 15.0234 6.18164 15.2108 6.07279 15.3688C5.96393 15.5267 5.80938 15.6476 5.62986 15.7153C5.42314 15.7764 5.20585 15.7932 4.99219 15.7646C4.77853 15.736 4.57331 15.6626 4.38993 15.5493C3.72892 15.176 3.06792 14.8027 2.40693 14.4294C2.36313 14.4087 2.32675 14.375 2.30268 14.3329C2.2786 14.2909 2.268 14.2424 2.27229 14.1941C2.27229 11.3983 2.27229 8.6025 2.27229 5.80688C2.26769 5.7525 2.2804 5.69805 2.3086 5.65132C2.33679 5.60459 2.37904 5.56797 2.42929 5.54668C4.90483 4.15243 7.3799 2.75671 9.85449 1.35953C9.89747 1.33018 9.94833 1.31451 10.0004 1.31459C10.0524 1.31466 10.1032 1.33048 10.1461 1.35996C12.6216 2.75465 15.0969 4.14983 17.5721 5.5455C17.6222 5.56738 17.6641 5.60433 17.6921 5.6512C17.7201 5.69807 17.7327 5.75251 17.7283 5.80692C17.7278 8.60231 17.7276 11.3979 17.7274 14.1938C17.7318 14.2422 17.7215 14.2909 17.6977 14.3334C17.674 14.3759 17.638 14.4103 17.5945 14.432C15.1569 15.8104 12.7179 17.1868 10.2777 18.5611C10.1611 18.6261 10.0231 18.7306 9.88678 18.6519C9.24768 18.2901 8.61639 17.9143 7.97943 17.5492C7.94687 17.5243 7.90762 17.5096 7.8667 17.5072C7.82578 17.5047 7.78506 17.5145 7.74975 17.5354C7.46919 17.6998 7.17388 17.8376 6.86767 17.947C6.72961 18.0029 6.55975 18.0188 6.46472 18.1469C6.58585 18.2787 6.7326 18.3844 6.89599 18.4575C7.64093 18.8888 8.38626 19.3198 9.13199 19.7503C9.37863 19.9052 9.66228 19.9912 9.95341 19.9993C10.2445 20.0074 10.5325 19.9373 10.7874 19.7963C13.2714 18.3957 15.7554 16.9944 18.2392 15.5924C18.4876 15.4627 18.6963 15.2684 18.8433 15.03C18.9904 14.7915 19.0704 14.5178 19.0749 14.2377V5.76346C19.0728 5.49369 18.9998 5.22921 18.8634 4.9965C18.7269 4.7638 18.5317 4.57104 18.2972 4.43753H18.2972Z" />
          </svg>
        ),
      },

      {
        name: ' API Reference',
        endpoint: 'https://developer.tradly.app/',
        blank_target: true,
        icon: (
          <svg
            className={`w-5 h-4 flex-shrink-0 fill-current   `}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10.9999 7C10.2088 7 9.43546 7.2346 8.77766 7.67412C8.11986 8.11365 7.60717 8.73836 7.30442 9.46927C7.00167 10.2002 6.92246 11.0044 7.0768 11.7804C7.23114 12.5563 7.6121 13.269 8.17151 13.8284C8.73092 14.3878 9.44365 14.7688 10.2196 14.9231C10.9955 15.0775 11.7998 14.9983 12.5307 14.6955C13.2616 14.3928 13.8863 13.8801 14.3258 13.2223C14.7653 12.5645 14.9999 11.7911 14.9999 11C14.9999 9.93913 14.5785 8.92172 13.8284 8.17157C13.0782 7.42143 12.0608 7 10.9999 7ZM10.9999 13C10.6044 13 10.2177 12.8827 9.8888 12.6629C9.5599 12.4432 9.30355 12.1308 9.15218 11.7654C9.0008 11.3999 8.9612 10.9978 9.03837 10.6098C9.11554 10.2219 9.30602 9.86549 9.58573 9.58579C9.86543 9.30608 10.2218 9.1156 10.6098 9.03843C10.9977 8.96126 11.3999 9.00087 11.7653 9.15224C12.1308 9.30362 12.4431 9.55996 12.6629 9.88886C12.8826 10.2178 12.9999 10.6044 12.9999 11C12.9999 11.5304 12.7892 12.0391 12.4142 12.4142C12.0391 12.7893 11.5304 13 10.9999 13ZM20.7099 10.29L18.3599 8V4.64C18.3599 4.37478 18.2546 4.12043 18.067 3.93289C17.8795 3.74536 17.6252 3.64 17.3599 3.64H14.0499L11.7099 1.29C11.617 1.19627 11.5064 1.12188 11.3845 1.07111C11.2627 1.02034 11.132 0.994202 10.9999 0.994202C10.8679 0.994202 10.7372 1.02034 10.6154 1.07111C10.4935 1.12188 10.3829 1.19627 10.2899 1.29L7.99994 3.64H4.63994C4.37472 3.64 4.12037 3.74536 3.93283 3.93289C3.7453 4.12043 3.63994 4.37478 3.63994 4.64V8L1.28994 10.29C1.19621 10.383 1.12182 10.4936 1.07105 10.6154C1.02028 10.7373 0.994141 10.868 0.994141 11C0.994141 11.132 1.02028 11.2627 1.07105 11.3846C1.12182 11.5064 1.19621 11.617 1.28994 11.71L3.63994 14.05V17.36C3.63994 17.6252 3.7453 17.8796 3.93283 18.0671C4.12037 18.2546 4.37472 18.36 4.63994 18.36H7.99994L10.3399 20.71C10.4329 20.8037 10.5435 20.8781 10.6654 20.9289C10.7872 20.9797 10.9179 21.0058 11.0499 21.0058C11.182 21.0058 11.3127 20.9797 11.4345 20.9289C11.5564 20.8781 11.667 20.8037 11.7599 20.71L14.0999 18.36H17.4099C17.6752 18.36 17.9295 18.2546 18.117 18.0671C18.3046 17.8796 18.4099 17.6252 18.4099 17.36V14.05L20.7599 11.71C20.8505 11.6138 20.921 11.5006 20.9676 11.3769C21.0141 11.2533 21.0356 11.1216 21.031 10.9896C21.0264 10.8575 20.9956 10.7277 20.9405 10.6077C20.8854 10.4876 20.807 10.3796 20.7099 10.29ZM16.6599 12.93C16.5655 13.0226 16.4903 13.1331 16.4388 13.2549C16.3873 13.3768 16.3605 13.5077 16.3599 13.64V16.36H13.6399C13.5076 16.3605 13.3767 16.3873 13.2549 16.4388C13.133 16.4903 13.0226 16.5655 12.9299 16.66L10.9999 18.59L9.06994 16.66C8.97732 16.5655 8.86688 16.4903 8.745 16.4388C8.62313 16.3873 8.49225 16.3605 8.35994 16.36H5.63994V13.64C5.63939 13.5077 5.61259 13.3768 5.56109 13.2549C5.5096 13.1331 5.43443 13.0226 5.33994 12.93L3.40994 11L5.33994 9.07C5.43443 8.97739 5.5096 8.86694 5.56109 8.74507C5.61259 8.62319 5.63939 8.49231 5.63994 8.36V5.64H8.35994C8.49225 5.63945 8.62313 5.61265 8.745 5.56115C8.86688 5.50966 8.97732 5.43449 9.06994 5.34L10.9999 3.41L12.9299 5.34C13.0226 5.43449 13.133 5.50966 13.2549 5.56115C13.3767 5.61265 13.5076 5.63945 13.6399 5.64H16.3599V8.36C16.3605 8.49231 16.3873 8.62319 16.4388 8.74507C16.4903 8.86694 16.5655 8.97739 16.6599 9.07L18.5899 11L16.6599 12.93Z" />
          </svg>
        ),
      },
    ],
  },
  {
    title: '  LEARNING & RESOURCES',
    child: [
      {
        name: '  Get Started',
        endpoint: '/docs/setup',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`w-5 h-5 flex-shrink-0   `}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
            />
          </svg>
        ),
      },

      {
        name: 'Roadmap',
        endpoint: 'https://github.com/TRADLY-PLATFORM/puffin/projects/1',
        blank_target: true,
        icon: (
          <svg
            className={`w-5 h-4 flex-shrink-0 fill-current   `}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 10.5V15.5C0 15.7652 0.105357 16.0196 0.292893 16.2071C0.48043 16.3946 0.734784 16.5 1 16.5H2C2 17.2956 2.31607 18.0587 2.87868 18.6213C3.44129 19.1839 4.20435 19.5 5 19.5C5.79565 19.5 6.55871 19.1839 7.12132 18.6213C7.68393 18.0587 8 17.2956 8 16.5H14C14 17.2956 14.3161 18.0587 14.8787 18.6213C15.4413 19.1839 16.2044 19.5 17 19.5C17.7956 19.5 18.5587 19.1839 19.1213 18.6213C19.6839 18.0587 20 17.2956 20 16.5H21C21.2652 16.5 21.5196 16.3946 21.7071 16.2071C21.8946 16.0196 22 15.7652 22 15.5V3.5C22 2.70435 21.6839 1.94129 21.1213 1.37868C20.5587 0.816071 19.7956 0.5 19 0.5H10C9.20435 0.5 8.44129 0.816071 7.87868 1.37868C7.31607 1.94129 7 2.70435 7 3.5V5.5H5C4.53426 5.5 4.07493 5.60844 3.65836 5.81672C3.24179 6.025 2.87944 6.32741 2.6 6.7L0.2 9.9C0.170751 9.94347 0.147224 9.99052 0.13 10.04L0.0700001 10.15C0.0258661 10.2615 0.00215505 10.3801 0 10.5ZM16 16.5C16 16.3022 16.0586 16.1089 16.1685 15.9444C16.2784 15.78 16.4346 15.6518 16.6173 15.5761C16.8 15.5004 17.0011 15.4806 17.1951 15.5192C17.3891 15.5578 17.5673 15.653 17.7071 15.7929C17.847 15.9327 17.9422 16.1109 17.9808 16.3049C18.0194 16.4989 17.9996 16.7 17.9239 16.8827C17.8482 17.0654 17.72 17.2216 17.5556 17.3315C17.3911 17.4414 17.1978 17.5 17 17.5C16.7348 17.5 16.4804 17.3946 16.2929 17.2071C16.1054 17.0196 16 16.7652 16 16.5ZM9 3.5C9 3.23478 9.10536 2.98043 9.29289 2.79289C9.48043 2.60536 9.73478 2.5 10 2.5H19C19.2652 2.5 19.5196 2.60536 19.7071 2.79289C19.8946 2.98043 20 3.23478 20 3.5V14.5H19.22C18.9388 14.1906 18.5961 13.9435 18.2138 13.7743C17.8315 13.6052 17.418 13.5178 17 13.5178C16.582 13.5178 16.1685 13.6052 15.7862 13.7743C15.4039 13.9435 15.0612 14.1906 14.78 14.5H9V3.5ZM7 9.5H3L4.2 7.9C4.29315 7.7758 4.41393 7.675 4.55279 7.60557C4.69164 7.53615 4.84475 7.5 5 7.5H7V9.5ZM4 16.5C4 16.3022 4.05865 16.1089 4.16853 15.9444C4.27841 15.78 4.43459 15.6518 4.61732 15.5761C4.80004 15.5004 5.00111 15.4806 5.19509 15.5192C5.38907 15.5578 5.56725 15.653 5.70711 15.7929C5.84696 15.9327 5.9422 16.1109 5.98079 16.3049C6.01937 16.4989 5.99957 16.7 5.92388 16.8827C5.84819 17.0654 5.72002 17.2216 5.55557 17.3315C5.39112 17.4414 5.19778 17.5 5 17.5C4.73478 17.5 4.48043 17.3946 4.29289 17.2071C4.10536 17.0196 4 16.7652 4 16.5ZM2 11.5H7V14.28C6.40983 13.7526 5.63513 13.4797 4.84469 13.5209C4.05425 13.5621 3.31212 13.914 2.78 14.5H2V11.5Z" />
          </svg>
        ),
      },
      {
        name: 'Changelog',
        endpoint: 'https://community.tradly.app/c/api-changelog/11',
        blank_target: true,
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`w-5 h-5 flex-shrink-0  `}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
            />
          </svg>
        ),
      },
    ],
  },
  {
    title: '  CONTACT US',
    child: [
      {
        name: '  Send us an email',
        endpoint: 'mailto:team@tradly.app',
        type: 'email',
        icon: (
          <svg
            className={`w-5 h-4 flex-shrink-0  fill-current  `}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V13C0 13.7956 0.316071 14.5587 0.87868 15.1213C1.44129 15.6839 2.20435 16 3 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM16.59 2L10.71 7.88C10.617 7.97373 10.5064 8.04812 10.3846 8.09889C10.2627 8.14966 10.132 8.1758 10 8.1758C9.86799 8.1758 9.73728 8.14966 9.61542 8.09889C9.49356 8.04812 9.38296 7.97373 9.29 7.88L3.41 2H16.59ZM18 13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V3.41L7.88 9.29C8.4425 9.8518 9.205 10.1674 10 10.1674C10.795 10.1674 11.5575 9.8518 12.12 9.29L18 3.41V13Z" />
          </svg>
        ),
      },

      {
        name: '  Logout',
        endpoint: '#',
        isFunctionCall: true,
        func: () => logout_tradly(),
        blank_target: true,
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className={`w-5 h-5 flex-shrink-0   `}
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-5a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
            />
          </svg>
        ),
      },
    ],
  },
]

export var menus_icon = {
  logout_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      className={`w-5 h-5 flex-shrink-0   `}
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-5a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
      />
    </svg>
  ),
  super_admin: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      className={`w-5 h-5 flex-shrink-0    `}
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
      />
    </svg>
  ),
  editor: (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2196 13.9555C17.2636 10.0595 14.7915 6.03562 10.731 4.94761C6.14492 3.71877 -0.364424 6.91181 1.08416 11.0092C1.56325 12.3643 2.48817 12.6814 4.23088 12.7061L4.33978 12.7075C5.26123 12.7191 5.52041 12.7792 5.59794 12.9054C5.72536 13.1128 5.72679 13.4439 5.58387 14.3543C5.51634 14.7845 5.49418 14.9355 5.46808 15.1703C5.30897 16.6011 5.55075 17.7169 6.48838 18.7268C9.41611 21.8802 15.0412 18.3535 16.2196 13.9555ZM2.96979 10.3425C2.24104 8.28126 6.9056 5.99314 10.2134 6.87946C13.2298 7.68772 15.0393 10.6331 14.2878 13.4379C13.4497 16.5656 9.50636 19.0379 7.95406 17.366C7.47464 16.8496 7.35504 16.2977 7.45583 15.3913C7.47737 15.1975 7.49709 15.0631 7.55967 14.6645C7.77887 13.2683 7.77611 12.6302 7.30206 11.8585C6.70834 10.8921 6.00236 10.7282 4.36491 10.7076L4.25922 10.7063C3.29465 10.6926 3.06582 10.6141 2.96979 10.3425Z"
        fill="currentColor"
      />
      <path
        d="M6 10C5.30964 10 4.75 9.44036 4.75 8.75C4.75 8.05964 5.30964 7.5 6 7.5C6.69036 7.5 7.25 8.05964 7.25 8.75C7.25 9.44036 6.69036 10 6 10Z"
        fill="currentColor"
      />
      <path
        d="M9.75 10C9.05964 10 8.5 9.44036 8.5 8.75C8.5 8.05964 9.05964 7.5 9.75 7.5C10.4404 7.5 11 8.05964 11 8.75C11 9.44036 10.4404 10 9.75 10Z"
        fill="currentColor"
      />
      <path
        d="M12.25 13C11.5596 13 11 12.4404 11 11.75C11 11.0596 11.5596 10.5 12.25 10.5C12.9404 10.5 13.5 11.0596 13.5 11.75C13.5 12.4404 12.9404 13 12.25 13Z"
        fill="currentColor"
      />
      <path
        d="M10.75 16.5C10.0596 16.5 9.5 15.9404 9.5 15.25C9.5 14.5596 10.0596 14 10.75 14C11.4404 14 12 14.5596 12 15.25C12 15.9404 11.4404 16.5 10.75 16.5Z"
        fill="currentColor"
      />
      <path
        d="M14.3707 3.60451C14.8605 3.34411 15.466 3.52923 15.7253 4.01686C15.7308 4.02727 15.7362 4.03777 15.7413 4.04836L19.8336 12.4482C19.9869 12.7628 19.8635 13.1422 19.5545 13.3065C19.2452 13.471 18.8612 13.3618 18.6847 13.0592L13.9771 4.98893C13.6993 4.5127 13.8602 3.90144 14.3364 3.62364C14.3477 3.61704 14.3592 3.61066 14.3707 3.60451Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5375 3.48434C13.0238 4.39897 13.8434 4.65522 14.6347 4.23444C15.4262 3.81362 15.6726 2.99053 15.1863 2.07592C14.6289 1.0276 13.438 0.0775719 12.6482 0.497483C11.8585 0.917395 11.9801 2.43602 12.5375 3.48434ZM13.4204 3.01486C13.2581 2.70947 13.1315 2.26269 13.1007 1.8773C13.0806 1.62643 13.1063 1.45889 13.1151 1.40204C13.1171 1.38903 13.1182 1.38181 13.1176 1.38073C13.1183 1.38172 13.1245 1.38462 13.1356 1.38985C13.1866 1.41372 13.3408 1.48594 13.5391 1.64416C13.8414 1.88525 14.141 2.24 14.3034 2.54539C14.5316 2.97464 14.4668 3.19118 14.1653 3.3515C13.8641 3.51165 13.6488 3.44435 13.4204 3.01486Z"
        fill="currentColor"
      />
    </svg>
  ),
  marketplace: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.224 6.40491H15.8041H16.8815V14.6849C16.8815 15.5641 16.5614 16.4073 15.9915 17.029C15.4216 17.6507 14.6487 18 13.8428 18H10.0755C10.1045 17.9542 10.1319 17.9062 10.1575 17.856L11.0056 16.1918H13.8428C14.0242 16.1918 14.2038 16.1528 14.3713 16.0771C14.5389 16.0013 14.6912 15.8903 14.8195 15.7504C14.9477 15.6105 15.0495 15.4444 15.1189 15.2615C15.1883 15.0787 15.224 14.8828 15.224 14.6849V6.40491ZM6.67921 16.1918H3.84247C3.47614 16.1918 3.12481 16.033 2.86578 15.7504C2.60674 15.4678 2.46122 15.0845 2.46122 14.6849V6.40491H0.803711V14.6849C0.803711 15.5641 1.12386 16.4073 1.69374 17.029C2.26362 17.6507 3.03654 18 3.84247 18H7.60931C7.58029 17.9542 7.55289 17.9062 7.52729 17.856L6.67921 16.1918Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.51101 5.29972H5.12731C4.74315 5.29901 4.37494 5.13079 4.10352 4.83202C3.8339 4.53521 3.68169 4.13366 3.67969 3.7145L3.94484 0H6.96111V3.70613C6.96111 4.12878 6.80833 4.53411 6.53638 4.83297C6.26444 5.13183 5.8956 5.29972 5.51101 5.29972Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.3584 3.05176e-05H10.6426V3.70616C10.6426 4.12881 10.4899 4.53415 10.2179 4.833C9.94597 5.13186 9.57713 5.29976 9.19254 5.29976H8.8085C8.42391 5.29976 8.05507 5.13186 7.78312 4.833C7.51118 4.53415 7.3584 4.12881 7.3584 3.70616V3.05176e-05Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8732 5.29976H12.4892C12.1046 5.29976 11.7357 5.13186 11.4638 4.833C11.1918 4.53415 11.0391 4.12881 11.0391 3.70616V3.05176e-05H14.0581L14.3233 3.71453C14.3213 4.13416 14.1687 4.53612 13.8986 4.833C13.6266 5.13186 13.2578 5.29976 12.8732 5.29976Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.3667 0.837745L17.811 2.27393L17.8115 2.27549C17.9357 2.66718 17.9992 3.07896 17.9994 3.49373C17.9993 3.97223 17.8265 4.43116 17.5189 4.76978C17.2113 5.10834 16.794 5.29894 16.3586 5.29975C15.9233 5.29894 15.506 5.10834 15.1984 4.76978C14.8907 4.43114 14.7179 3.97215 14.7179 3.4936L14.7179 3.47541L14.1934 3.05176e-05H16.3556C16.5832 0.000588598 16.8045 0.0820063 16.9865 0.232134C17.1685 0.382303 17.3015 0.593165 17.3655 0.833229L17.3667 0.837745Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.80603 0.000123061L3.28147 3.4755V3.4937C3.28147 3.97224 3.10866 4.43123 2.80098 4.76987C2.49337 5.10843 2.07609 5.29903 1.64074 5.29985C1.42438 5.29944 1.21022 5.2521 1.01055 5.16053C0.810785 5.06891 0.629455 4.93483 0.476973 4.76599C0.324492 4.59714 0.203863 4.39686 0.122014 4.17664C0.0401653 3.95642 -0.00128575 3.7206 3.03862e-05 3.48272V3.30004C0.00104439 3.00987 0.0457453 2.72146 0.132077 2.44724L0.635458 0.837844L0.636836 0.83261C0.700123 0.592318 0.832801 0.381161 1.01485 0.230994C1.19691 0.0808274 1.41873 -0.00020481 1.64636 0.000123061H3.80603Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5262 6.70892C12.1831 6.70892 13.5262 8.05207 13.5262 9.70893V11.1818C13.5262 12.8387 12.1831 14.1818 10.5262 14.1818H10.4133C10.3944 14.2459 10.3693 14.3093 10.3376 14.3715L9.18541 16.6325C9.00658 16.9834 8.54701 16.9834 8.36818 16.6325L7.21601 14.3715C7.18433 14.3093 7.15922 14.2459 7.14029 14.1818H7.09375C5.4369 14.1818 4.09375 12.8387 4.09375 11.1818V9.70892C4.09375 8.05207 5.4369 6.70892 7.09375 6.70892H10.5262ZM6.43359 9.46431C6.43359 9.13294 6.70222 8.86431 7.03359 8.86431H10.5169C10.8482 8.86431 11.1169 9.13294 11.1169 9.46431C11.1169 9.79568 10.8482 10.0643 10.5169 10.0643H7.03359C6.70222 10.0643 6.43359 9.79568 6.43359 9.46431ZM7.83789 11.5231C7.50652 11.5231 7.23789 11.7917 7.23789 12.1231C7.23789 12.4544 7.50652 12.7231 7.83789 12.7231H9.7112C10.0426 12.7231 10.3112 12.4544 10.3112 12.1231C10.3112 11.7917 10.0426 11.5231 9.7112 11.5231H7.83789Z"
        fill="currentColor"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3690_5643"
          x1="16.8815"
          y1="18"
          x2="16.8815"
          y2="6.40491"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#066950" />
          <stop offset="1" stop-color="#0E8C79" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3690_5643"
          x1="6.96111"
          y1="5.29972"
          x2="6.96111"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#066950" />
          <stop offset="1" stop-color="#0E8C79" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3690_5643"
          x1="10.6426"
          y1="5.29975"
          x2="10.6426"
          y2="3.05176e-05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#066950" />
          <stop offset="1" stop-color="#0E8C79" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3690_5643"
          x1="14.3233"
          y1="5.29975"
          x2="14.3233"
          y2="3.05176e-05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#066950" />
          <stop offset="1" stop-color="#0E8C79" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3690_5643"
          x1="17.9994"
          y1="5.29975"
          x2="17.9994"
          y2="3.05176e-05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#066950" />
          <stop offset="1" stop-color="#0E8C79" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3690_5643"
          x1="3.80603"
          y1="5.29985"
          x2="3.80603"
          y2="0.00012207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#066950" />
          <stop offset="1" stop-color="#0E8C79" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3690_5643"
          x1="13.5262"
          y1="16.8957"
          x2="13.5262"
          y2="6.70892"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#066950" />
          <stop offset="1" stop-color="#0E8C79" />
        </linearGradient>
      </defs>
    </svg>
  ),
  cube: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
      />
    </svg>
  ),
}
